import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isoWeek from 'dayjs/plugin/isoWeek';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { Locale } from '@enmon/commons';
import timezone from 'dayjs/plugin/timezone';

dayjs.locale(Locale.CS);
dayjs.locale(Locale.SK);
dayjs.locale(Locale.PL, {
  // NOTE: It seems that AntD for v5.20.0 is missing months in pl_PL dayjs locale config
  //       so we have to add them manually. This extension can be unnecessary in future.
  months: [
    'Styczeń',
    'Luty',
    'Marzec',
    'Kwiecień',
    'Maj',
    'Czerwiec',
    'Lipiec',
    'Sierpień',
    'Wrzesień',
    'Październik',
    'Listopad',
    'Grudzień',
  ],
});

export const initializeDayJS = () => {
  // Extend dayjs with used plugins
  dayjs.extend(utc);
  dayjs.extend(isoWeek);
  dayjs.extend(dayOfYear);
  dayjs.extend(quarterOfYear);
  dayjs.extend(customParseFormat);
  dayjs.extend(isLeapYear);
  dayjs.extend(timezone);
};
